<template>
  <div class="parking_box">
    <section class="parking_mess">
        <section class="parking_mess_left">
            <h2 @click="parkSelectFun">
                <span>{{parkingMess.parkName}}</span>
                <a-icon class="icon" v-if="parkList.length > 1" type="caret-down"></a-icon>
            </h2>
            <p v-if="companyName">
                <img src="../../assets/images/parking/company.png" />
                <span>{{companyName}}</span>
            </p>
        </section>
        <section class="parking_mess_right">
            <p>总车位<span>{{parkingMess.personalMonthlyNumber}}</span></p>
            <p>剩余车位<span>{{parkingMess.overplusPMonthlyNumber}}</span></p>
            <section class="bg_trigger"></section>
        </section>
        <mt-popup v-model="parkSelect" position="bottom" class="park_popup">
            <mt-picker class="picker" :slots="dataList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
                <div class="picker_wrap">
                    <div class="picker_btn" @click="parkSelect=false">取消</div>
                    <div class="picker_btn2" @click="handleConfirm">确认</div>
                </div>
            </mt-picker>
        </mt-popup>
    </section>
    <section class="search_box">
        <section class="search_box_inpt">
            <img class="search_icon" src="../../assets/images/search.png" />
            <input type="text" placeholder="搜索车主/手机号/车牌" v-model="key" @input="inputFun" autofocus :focus="focus" />
            <img
            class="clear_img"
            @click.stop="searchClear"
            v-if="key.length"
            src="../../assets/images/btn_clear.png"
            />
       </section>

    </section>
    <section class="search_box_mask" v-if="parkSelect"></section>

    <div class="top_box"></div>

    <div class="parking_list">
        <section class="parking_list_item" v-for="(item,index) in passList" :key="index">
            <!-- <div class="parking_list_item_line">
                <div class="parking_list_box">
                    <span class="span1" >申请人:</span>
                    <span class="span2">{{item.userName}}</span>
                </div>
                <div class="parking_list_box">
                    <span class="span1">联系电话:</span>
                    <span class="span2">{{item.phone}}</span>
                </div>
            </div> -->
            
            <section  v-for="(pItem,pIndex) in item.prkParkLotBeanList" :key="pIndex" >
                 <div v-if="pIndex!=0" class="parking_list_item_line22"></div>
                 <div class="parking_list_item_line">
                    <div class="parking_list_box">
                        <span class="span1" >申请人:</span>
                        <span class="span2">{{pItem.userName}}</span>
                    </div>
                    <div class="parking_list_box">
                        <span class="span1">联系电话:</span>
                        <span class="span2">{{pItem.phone}}</span>
                    </div>
                </div>
                <div class="parking_list_item_line2"></div>
                <div class="parking_list_item_line1">
                        <span class="span1">车牌号</span>
                        <div class="tipDiv" v-for="(carNo) in pItem.carNoList" :key="carNo"><span>{{carNo}}</span> </div>
                         
                </div>
               <section class="parking_list_cItem" v-for="(cItem,cIndex) in pItem.prkParkApplyLogBeans" :key="cIndex" @click="applyDetail(cItem,pItem)">
                    <!-- <div class="parking_list_item_line2"></div> -->
                    <div class="parking_list_item_line3">
                        <img class="icon" src="../../assets/images/icon_contract.png" />
                        <span class="span1">{{cItem.applyStartDay | applyDayFormat}} 至 {{cItem.applyEndDay | applyDayFormat}}</span>
                    <!---->
                        <template v-if="pItem.prkParkApplyLogBeans.length == 1 || cIndex ==0" >
                            <span  v-if="cItem.daoqi"  class="daoqi" >即将到期</span>
                        </template>
                        <!-- 存在2条数据 第一条是审批中 或者审批失败-->
                        <template v-else-if="pItem.prkParkApplyLogBeans.length == 2 && cIndex ==1 && (pItem.prkParkApplyLogBeans[0].applyStatus ==1 || pItem.prkParkApplyLogBeans[0].applyStatus ==3)" >
                            <span  v-if="cItem.daoqi"  class="daoqi" >即将到期</span>
                        </template>
                        <template v-if="cItem.sendStatus == 2 || cItem.applyStatus == 0 ||cItem.applyStatus == 7">
                            <!-- <span :class="['status',cItem.applyStatus == 3?'status_fail':'']" v-if="cItem.applyStatus != 2 && cItem.applyStatus != 4 && cItem.applyStatus != 7">{{cItem.applyStatus | applyStatus}}</span> -->
                            <template v-if="cItem.sendStatus == 2 || cItem.applyStatus == 0 ||cItem.applyStatus == 7">
                                <span :class="['status',cItem.applyStatus == 3?'status_fail':'']" v-if="cItem.applyStatus != 2 && cItem.applyStatus != 4 && cItem.applyStatus != 7">{{cItem.applyStatus | applyStatus}}</span>
                                <img v-else-if="cItem.applyStatus == 2" class="succ_icon" src="../../assets/images/icon_take_effect.png">
                                <img v-else-if="cItem.applyStatus == 7" class="succ_icon" src="../../assets/images/icon_was_due.png">
                                <img class="succ_icon" v-else src="../../assets/images/icon_take_effectt.png">
                           </template>
                        </template>
                        <span v-else class="status">待提交</span>
                    </div>
                
                    <div class="parking_list_item_line11">
                        <span class="span1">月租车费</span>
                        <span class="span3">{{cItem.feeStandard}}</span>
                        <span class="span4">元/月</span>
                    </div>
                    <div class="parking_list_item_line4" v-if="cItem.reason">
                        <span class="span1">拒绝理由</span>
                        <span class="span2">{{cItem.reason}}</span>
                    </div>
                    <section :class="[cItem.sendStatus == 2&& cItem.applyStatus ==2 && item.startDay ?'status_bottom1':'status_bottom']">
                        <template v-if="cItem.sendStatus == 2 || cItem.applyStatus == 0">
                            <span @click.stop="delectContract(cItem ,pItem)" v-if="cItem.applyStatus == 4 || cItem.applyStatus == 3" class="btn_primary delete">删除</span>
                            <span v-else class="btn_primary ">查看详情</span>
                        </template>
                    
                    </section>
                </section>
               
                <template
                    v-if="!pItem.showXuqianTips  && pItem.applyStatus == 2 && (!pItem.prkParkMonthlyBillBeans || pItem.prkParkMonthlyBillBeans.length == 0) && !(pItem.prkParkApplyLogBeans.length == 1 && pItem.prkParkApplyLogBeans[0].applyStatus == 3)"
                >
                   
                    <section class="hb_tips" v-if="pItem.showPaytips">
                        <img class="hint_icon" src="../../assets/images/parking/icon_hint.png" />
                        <p>您当前还没有缴费，请点击下方缴费按钮，缴费成功后可享受月租优惠！</p>
                        <img
                                class="close_icon"
                                @click="pItem.showPaytips = false"
                                src="../../assets/images/parking/close.png"
                            />
                    </section>
                </template>
                <template v-if="pItem.showXuqianTips && pItem.nopay_tips && !pItem.hasTwoContract">
                        <section class="hb_tips" v-if="pItem.showPaytips">
                            <img class="hint_icon" src="../../assets/images/parking/icon_hint.png" />
                            <p>
                                您的优惠资格距离失效还有
                                <span>{{pItem.lastDays+1}}</span>天，请尽快操作续签，以免影响正常使用！
                            </p>
                            <img
                                class="close_icon"
                                @click="pItem.showPaytips = false"
                                src="../../assets/images/parking/close.png"
                            />
                        </section>
                </template>
                <!--   v-if="!showXuqianTips && applyMess && applyData.applyStatus !=7 && !repeatApply && showQjf || hasTwoContract" -->
                <div class="parking_list_item_line5" v-if="(!pItem.showXuqianTips && pItem.showQjf &&pItem.applyStatus !=7) || pItem.hasTwoContract" >
                    <div class="parking_list_item_bt" @click.stop="toPay(pItem)"> <span>去缴费</span></div>
                </div>
                <!-- && !repeatApply -->
                <section class="parking_list_item_line6" v-if=" pItem.showXuqianTips  && !pItem.hasTwoContract">
                    <span class="footer_btn left" @click.stop="toPay(pItem)">去缴费</span>
                    <span class="footer_btn right" @click.stop="toXuqian(pItem)">去续签</span>
                </section>

            </section>
                
           
            
           
           
           

        </section>
    </div>
    <div class="bottom_box" ></div>

     <common-footer

        text="新增车位"
        :canClick="true"
        @btnClick="addAction"
      ></common-footer>

  </div>
</template> 

<script>
import util from '../../utils/util';
import { approvalMixin } from '../../utils/approvalMixin';
import storage from '../../utils/storage';
import CommonFooter from '../../components/footer';
import { loadParkHeaderById, spaceUpPcHttp } from '../../utils/api';
import { mapState } from 'vuex';
let timer = "";
export default {
  name: 'parkingCompanyPass',
  props: {},
  mixins: [approvalMixin],
  components: {
    CommonFooter,
  },
   data() {
        return {
            companyName:'',
            key:'',
            parkingMess:{},
            parkList:[],
            dataList:[{
                flex: 1,
                values: [],
                className: 'slot1',
                textAlign: 'center'
            }],
            parkSelect:false,
            parkId:'',
            isShowAgree:false,
            mustImg:'',
            userName:'',
            passList:[],
        }
    },
    computed: {
        ...mapState({
            common: state => state.common
        })
    },
     created(){
        // 有默认企业,且没有申请过,显示默认企业名称 && !this.applyData.id
        if(this.$store.state.common.userTenantInfo.company ){
            this.companyName = this.$store.state.common.userTenantInfo.company
        }
        // // 有申请车位的公司名称显示申请时候的公司名称
        // if(this.applyData.companyName){
        //     this.companyName = this.applyData.companyName;
        // }
        // this.getParkId()
    },
    activated(){
       
        this.getParkId()
    },
    methods:{
         getParkId() {
            console.log('in getParkId')
            util.showLoading()
            let params = {
                subProjectId: this.common.marketInfo.id,
                url: "/parking/rstParkHeader/queryParkHeaderList"
            }
            loadParkHeaderById(params).then(res => {
                util.hideLoading()
                console.log(res)
                if (res.res && res.res.code === 10000 && res.body && res.body.data) {
                let mess = res.body.data || []
                if (mess.length === 0) {
                    util.showToast('没有停车场信息')
                    return;
                }
                if (storage.get("parkingMess" + this.common.marketInfo.id)) {
                    var saveMess = JSON.parse(storage.get("parkingMess" + this.common.marketInfo.id));
                    var hasSaveMsee =false;
                    for (var i=0;i<mess.length;i++){
                    if( mess[i].id ==saveMess.id){
                        this.parkingMess= mess[i];
                        hasSaveMsee = true;
                    }
                    }
                    if(!hasSaveMsee){
                        this.parkingMess=mess[0];
                    }
                    //this.parkingMess = JSON.parse(storage.get("parkingMess" + this.common.marketInfo.id))
                    this.parkId = this.parkingMess.id;
                    this.mustImg = this.parkingMess.mustImg
                } else {
                    this.mustImg = mess[0].mustImg
                    this.parkId = mess[0].id
                    this.parkingMess = mess[0]
                }
                this.parkList = mess;
                var showAgree =this.parkingMess.enableMonthNotice;
                if(showAgree !=2){
                    this.isShowAgree =true
                }else{
                    this.isShowAgree =false;
                }
                storage.setS("mustImg", this.mustImg)
                this.loadParkHeaderById()// 获取停车场信息
                this.loadParkLot()//获取用户申请信息
                } else {
                util.showToast(res.res.msg)
                }
            })
         },
         loadParkHeaderById() {
            util.showLoading();
            let params = {
                id: this.parkId,
                url: "/parking/rstParkHeader/loadParkHeaderById"
            }
            loadParkHeaderById(params).then(res => {
                util.hideLoading()
                console.log(res)
                if (res.res && res.res.code === 10000 && res.body) {
                    this.parkingMess = res.body.data
                    if (res.body.data.prkParkFeeBeanList && res.body.data.prkParkFeeBeanList.length > 0) {
                        let newL = res.body.data.prkParkFeeBeanList.filter(item => { return item.parkType == 4 })
                        this.prkParkFeeBeanList = newL;
                        // this.dayNightType = newL[0].dayNightType;//设置默认选中套餐
                        // this.ParkFeeId = newL[0].id;
                        // this.feeTypeName = newL[0].parkTypeName;
                        // this.vipTypeCode = newL[0].typeCode;
                        // this.vipTypeName = newL[0].typeName;
                        // this.maxEndDay = newL[0].maxEndDay;//价格区间最大日期
                        if (newL.length == 0) {
                        util.showModal('', '该项目停车场尚未配置停车月租优惠', false, '我知道了', () => {
                            // this.$router.go(-1)
                        })
                        }
                    }
                } else {
                    util.showToast(res.res.msg)
                }
            })
        },
        loadParkLot(){
             util.showLoading()
             //{"head":{"version":"1.0.0","openId":"okABn6tHuADRlpeXX9XfpP-22HxU",
             // "userId":"ED0DFE9A34774059A73E61B80E2599F3","cityId":"2","marketId":"2",
             // "memberCode":"6800910056985460835"},
            //  userName传模糊搜索
             // "body":{"companyId":"5575","parkHeaderId":26,
             // "userName":"宁A83217","url":"/parking/rstParkLot/loadMyCompanyParkLots"}}

             let params = {
                    companyId: this.common.userTenantInfo.companyId,
                    userName: this.key,
                    parkHeaderId: this.parkId,
                    url: "/parking/rstParkLot/loadMyCompanyParkLots"
             }

              loadParkHeaderById(params).then(res => {
                    // console.log('loadMyCompanyParkLots === ' + JSON.stringify(res) )
                    if (res.res && res.res.code === 10000 && res.body && res.body.data) {
                   
                    
                        var list = res.body.data || []
                        for(var n=0;n<list.length;n++){
                            var nItem = list[n]
                            if(nItem.prkParkLotBeanList && nItem.prkParkLotBeanList.length > 0){
                                nItem.phone = nItem.prkParkLotBeanList[0].phone
                                nItem.userName = nItem.prkParkLotBeanList[0].userName
                                nItem.showPaytips =true

                                for(var i=0;i<nItem.prkParkLotBeanList.length;i++){
                                    var item = nItem.prkParkLotBeanList[i]
                                    item.showPaytips =true
                                    // console.log('item === ' + JSON.stringify(item) )
                                    if(new Date(item.applyEndDay.replace(/\./g,'/')).getTime()-new Date().getTime()<24*60*60*30*1000 &&
                                        new Date(item.applyEndDay.replace(/\./g,'/')).getTime()-new Date().getTime() > 0 &&
                                        item.applyStatus == 2){
                                        item.daoqi = true
                                    }
                                     if(item.plateNo){
                                                item.carNoList = item.plateNo.split(',')
                                     }else{
                                               item.carNoList = []
                                     }
                                    let contractDate = item.prkParkApplyLogBeans || [];
                                    if (contractDate.length > 0) {
                                        let status2Num = 0;//成功的合同数量
                                        let status4Num = 0;//失败的合同数量
                                        let status1Num = 0;//审批中的合同数量
                                        for(var j=0;j<contractDate.length;j++){
                                            var jItem=contractDate[j]
                                            if(new Date(jItem.applyEndDay.replace(/\./g,'/')).getTime()-new Date().getTime()<24*60*60*30*1000 &&
                                                new Date(jItem.applyEndDay.replace(/\./g,'/')).getTime()-new Date().getTime() > 0 &&
                                                jItem.applyStatus == 2){
                                                jItem.daoqi = true
                                            }
                                           
                                          
                                            if (jItem.applyStatus == '2') {
                                                status2Num += 1;
                                            } else if (jItem.applyStatus == '1') {
                                                status1Num += 1;
                                            } else if (jItem.applyStatus == '4') {
                                                status4Num += 1;
                                            }

                                        }

                                        if (status2Num == 0) {
                                            // 审批中的有一个
                                            if (status1Num == 0) {
                                                item.repeatApply = true
                                            } else {
                                                item.repeatApply = false
                                            }
                                        } else if (status2Num == 1) {//一个合同生效
                                            item.showQjf = true;
                                            contractDate.forEach(jItem => {
                                                if (jItem.applyStatus == '2') {
                                                // this.dayNightType = item.dayNightType;
                                                // this.ParkFeeId = item.id;
                                                // this.feeTypeId = item.feeTypeId;
                                                // this.feeTypeName = item.parkTypeName;
                                                // this.vipTypeCode = item.typeCode;
                                                // this.vipTypeName = item.typeName;
                                                // 判断该数据的结束时间是否小于当前的30天
                                                    let d = Math.floor((new Date(jItem.applyEndDay.replace(/\./g, '/')).getTime() - new Date().getTime()) / (24 * 60 * 60 * 1000));
                                                    if (status1Num == 1) {
                                                        item.showXuqianTips = false;
                                                    } else {
                                                        if (d < 30 && d >= -1) {
                                                            item.showXuqianTips = true;
                                                            item.showQjf = false;
                                                            item.nopay_tips = true;
                                                            item.lastDays = d
                                                        } else {
                                                            item.showXuqianTips = false;
                                                        }
                                                    }
                                                }
                                            })
                                        } else if (status2Num == 2) {
                                            item.hasTwoContract = true
                                        }

                                    }else{
                                        item.applyMess = false;
                                        item.repeatApply = false;
                                        item.showXuqianTips = false
                                        item.hasTwoContract = false

                                    }

                                }
                                
                            }
                           
                           
                           
                        }
                        this.passList = list
                    } else{
                        this.passList = []
                    }
                    util.hideLoading()
                    this.showPage = true;
              })

        },

         parkSelectFun(){
            if(this.parkList.length <= 1){
                return;
            }
            this.parkSelect = true
            this.dataList[0].values = []
            this.parkList.forEach(item=>{
                this.dataList[0].values.push(item.parkName)
            })
        },
        onValuesChange (picker, values) {
            if (values[0] > values[1]) {
                picker.setSlotValue(1, values[0]);
            }
        },
        handleConfirm(){
            this.parkSelect = false
            var val = this.$refs.picker.getValues()[0];
            console.log(val)
            // this.parkingMess=value
            // this.$emit('parkSelect',value)
              this.parkList.forEach(item => {
                if (val === item.parkName) {
                    this.parkingMess = item;
                    this.canClick = false;
                    // this.showXuqianTips = false;
                    // this.applyMess = false;
                    // this.repeatApply = false;
                    // this.showQjf = false;
                    // this.hasTwoContract = false;
                    this.mustImg = item.mustImg
                    var showAgree =this.parkingMess.enableMonthNotice;
                    if(showAgree !=2){
                        this.isShowAgree =true
                    }else{
                        this.isShowAgree =false;
                    }
                    console.log(JSON.stringify(this.parkingMess),'this.parkingMess' )
                    storage.set("parkingMess" + this.common.marketInfo.id, JSON.stringify(item))
                    this.parkId = item.id
                    this.loadParkHeaderById()// 获取停车场信息
                    this.loadParkLot()//获取用户申请信息
                }
             })
        },
       


         applyDetail(item,pItem){
            console.log(JSON.stringify(item),'item' )
            console.log(JSON.stringify(pItem),'item' )
            storage.setS("addPass_parkingContract", JSON.stringify(item))
            // this.$router.push("/parkingApplyDetail?id="+item.id+"&applyId="+item.parkHeaderId)
            this.$router.push("/parkingCompanyApplyDetail?parkHeaderId="+pItem.parkHeaderId+"&parkingSpaceId="+pItem.id+'&contractId='+item.id )
         },



        addAction(){
            
            storage.setS("addPass_parkingMess", JSON.stringify(this.parkingMess))
            this.$router.push({
                path: "/CompanyParkingAddPass"
            });

        },

         // 删除合同
        delectContract(item,pItem) {
            util.showModal("", '确定要删除该数据吗?', true, "确定", () => {
                util.showLoading()
                var params={}
               
                 params= {
                        parkLotId: item.parkLotId,
                        id: item.id,
                        url: "/parking/rstParkLot/delApplay"  
                }
                 // 有多个合同删除合同 只有一个合同删除车位2
                // if(pItem.prkParkApplyLogBeans.length>=2){
                //      params= {
                //         parkLotId: item.parkLotId,
                //         id: item.id,
                //         url: "/parking/rstParkLot/delApplay"  
                //     }
                // }else{
                //     params= {
                //         id:pItem.id,
                //         url: "/parking/rstParkLot/delParkLot"
                //     }
                // }
              
                loadParkHeaderById(params).then(res => {
                    util.hideLoading()
                    console.log(res)
                    if (res.res && res.res.code === 10000) {
                        
                        // 获取停车场信息
                        this.loadParkHeaderById()
                        this.loadParkLot()//获取用户申请信息
                    } else {
                        util.showToast(res.res.msg)
                    }
                })
            });
        },
         toPay(item) {
            if (item.prkParkApplyLogBeans.length >= 2 && item.hasTwoContract) {
                this.$router.push(`/parkingPay?id=${item.id}&parkHeaderId=${item.parkHeaderId}&xqContractId=${item.prkParkApplyLogBeans[0].id}`)
            } else {
                this.$router.push(`/parkingPay?id=${item.id}&parkHeaderId=${item.parkHeaderId}`)
            }
        },
         toXuqian(item) {
            // dayNightType : 续签 获取默认的 价格区间的最大日期
            this.$router.push(`/parkingCompanyxuqian?parkId=${item.parkHeaderId}&dayNightType=${item.dayNightType}&ParkFeeId=${item.id}&feeTypeId=${item.feeTypeId}&approval=${this.parkingMess.enableRenewalApproval}`)
        },
        showData(item){
            console.log(JSON.stringify(item),'item')  
        },

         searchClear() {
            this.key = "";
            this.searchEnd = 0;
            this.passList = [];
            this.loadParkLot();
        },
        inputFun() {
        //键盘输入时触发input事件
            clearTimeout(timer);
            var that = this;
            that.passList = [];
            if (that.key.length === 0 && that.key.length === 0) {
                //如果输入框为空
                that.searchEnd = 0;
                timer = setTimeout(function() {
                    that.loadParkLot();
                }, 800);
            } else {
                that.searchEnd = 2;
                timer = setTimeout(function() {
                    that.loadParkLot();
                }, 800);
            }
        },
    },
    filters:{
        applyDayFormat(val){
            if(val && val.length > 10){
                return val.substring(0,10)
            }

            return val
        },
         applyStatus(val){
            if(val == '0'){
                return '等待候补中'
            }else if(val== '1'){
                return '审批中'
            }else if(val == '3'){
                return '审批失败'
            }else if(val == '4'){
                return '已解绑'
            }else if(val == '7'){
                return '已失效'
            }else{
                return '已解绑'
            }
        },
    }

}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.parking_box {
  background: #eee;
}
.parking_mess {
  width: 100%;
  height: 186px;
  position: fixed;
  z-index: 999;
  background: rgba(23, 64, 218, 1) url('../../assets/images/park_bg.jpg') left top no-repeat;
  background-size:100% 100%;
  .flex();
  flex-wrap:nowrap;
  justify-content: space-between;
  .parking_mess_left {
    flex: 1;
    padding-left:28px;
    overflow:hidden;
    h2 {
      height: 50px;
      font-size: 36px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      margin: 40px 0 22px;
      .flex();
      flex-wrap: nowrap;
      align-items: center;
      span{
        .textOver(100%);
      }
      .icon{
        margin-left:4px;
        font-size:32px;
        margin-top:10px;
        font-weight: bold;
      }
    }
    p {
      .flex();
      align-items: center;
      height:34px;
      overflow: hidden;
      align-items: center;
      img{
        display:block;
        width:34px;
        height:34px;
        margin-right:16px;
      }
      span{
        flex:1;
        .textOver(100%);
        font-size: 28px;
        color: rgba(255, 255, 255, 1);
        line-height: 34px;
      }
    }
  }
  .parking_mess_right{
    position: relative;
    padding-right:28px;
    // min-width:220px;
    .flex(column);
    justify-content: center;
    align-items: flex-end;
    padding-left:40px;
    height: 186px;
    overflow: hidden;
    white-space: nowrap;
    flex-shrink: 0;
    p{
      margin:11px 0;
      font-size:24px;
      color:rgba(255,255,255,1);
      line-height:34px;
      span{
        margin-left:10px;
        display:inline-block;
        font-size:32px;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:44px;
      }
    }
    .bg_trigger{
      display: none;
      width:30px;
      height:186px;
      background:rgba(23, 64, 218, 1);
      position:absolute;
      top:0;left:0;
      transform: rotate(10deg) translate(-10px);
    }
  }
}
.search_box{
    width: 100%;
    top:186px;
    left: 0;
    right: 0;
    height: 120px;
    position: fixed;
    z-index: 999;
    background: #eee;
    padding-left: 20px;
    padding-right: 20px;
    .flex();
   
    .search_box_inpt {
        width: 710px;
        margin-top: 20px;
        height: 80px;
        background: #fff;
        border-radius: 8px;
        position: relative;
        .flex();
        align-items: center;
        .search_icon {
            width: 44px;
            height: 44px;
            display: block;
            margin: 0 14px;
        }
        input {
            flex: 1;
            font-size: 28px;
            color: rgba(51, 51, 51, 1);
            background: transparent;
            height: 80px;
        }
        .clear_img {
            position: absolute;
            width: 44px;
            height: 44px;
            padding: 12px;
            top: 0;
            right: 0;
        }
    }

}
.search_box_mask{
    width: 100%;
    top:186px;
    left: 0;
    right: 0;
    height: 120px;
    position: fixed;
    z-index: 1999;
    background: rgba(0,0,0,0.5);;

}
.top_box{
    width: 100%;
    height: 306px;
    background: #eee;
    display: flex;
}

.parking_list{
    margin-top:0px;
    margin-bottom: 100px;
    .flex(column);
    .parking_list_item{
        background:rgba(255,255,255,1);
        border-radius:10px;
        margin-bottom:40px;
        margin-left: 25px;
        margin-right: 25px;
        padding: 20px;
        padding-top: 0px;
        .flex(column);
        .parking_list_item_line{
            width: 660px;
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            .parking_list_box{
                width: 330px;
                display: flex;
                flex-direction: row;
                .span1{
                    margin-right: 12px;
                    font-weight: 500;
                    line-height: 50px;
                    font-size: 28px;
                    color: rgba(0, 0, 0, 1);
                }
                .span2{
                    
                    font-weight: 500;
                    line-height: 50px;
                    font-size: 28px;
                    color: rgba(0, 0, 0,0.8);
                }
            }   
        }
        .parking_list_item_line1{
            margin-top: 20px;
            width: 660px;
            display: flex;
            flex-direction: row;
            position: relative;
            z-index: 20;
            .span1{
                display: flex;
                width: 125px;
                font-size: 26px;
                line-height: 40px;
                color: rgba(0, 0, 0, 0.8);
            }
            .tipDiv{
                position: relative;
                z-index: 20;
                margin-right: 20px;
                padding-left: 15px;
                padding-right: 15px;
                background-color: #0087ff;
                border-radius: 10px;
                height: 40px;
                font-size: 24px;
                line-height: 40px;
                color: #fff;
            }
            .succ_icon{
                position: absolute;
                z-index: 100;
                width:124px;height:124px;
                top:-60px;right:20px;
            }
            .span3{
                font-size: 24px;
                line-height: 40px;
                color:red;
            }
            .span4{
                
                font-size: 24px;
                line-height: 40px;
                color: rgba(0, 0, 0, 0.8);
            }
            
            
        }
        .parking_list_item_line2{
             margin-top: 20px;
            width: 660px;
            display: flex;
            height: 2px;
            background-color: rgba(0, 0, 0, 0.2);
            flex-direction: row;
            margin-bottom: 10px;
        }
        .parking_list_item_line22{
            margin-top: 40px;
            width: 660px;
            display: flex;
            height: 2px;
            background-color: rgba(0, 0, 0, 0.2);
            flex-direction: row;
            margin-bottom: 10px;

        }
        .parking_list_cItem{
            padding-left: 14px;
            padding-right: 14px;
            flex-direction: column;
            margin-top: 14px;
            width: 640px;
            padding-bottom: 20px;
            display: flex;
            background-color: #eee;
        }
         .parking_list_item_line11{
            margin-top: 20px;
            width: 632px;
            display: flex;
            flex-direction: row;
            position: relative;
            z-index: 20;
            .span1{
                display: flex;
                width: 125px;
                font-size: 26px;
                line-height: 40px;
                color: rgba(0, 0, 0, 0.8);
            }
          
            .span3{
                font-size: 26px;
                line-height: 40px;
                color:red;
            }
            .span4{
                
                font-size: 24px;
                line-height: 40px;
                color: rgba(0, 0, 0, 0.8);
            }
            
            
        }
        .parking_list_item_line3{
            margin-top: 20px;
            width: 632px;
            display: flex;
            position: relative;
            flex-direction: row;
            z-index: 100;
            .span1{
                
                font-size: 26px;
                line-height: 44px;
                color: rgba(0, 0, 0, 0.8);
            }
            .icon{
                width:44px;
                height:44px;
                margin-right:10px;
            }
            .daoqi{
                display:inline-block;
                height:40px;
                line-height:40px;
                padding:0 10px;
                border-radius: 20px;
                background:#fd9838;
                color:#fff;
                font-size:24px;
                margin-left:20px;
            }
            .succ_icon{
                position: absolute;
                z-index: 100;
                width:104px;height:104px;
                top:0px;right:20px;
            }
           .status{
                font-size:24px;
                color:rgba(253,152,56,1);
                display:inline-block;
                height:40px;
                line-height:40px;
                padding:0 10px;
                border-radius: 20px;
                
               
                font-size:24px;
                margin-left:20px;
            }
            .status_fail{
                color:#fc3f56;
                display:inline-block;
                height:40px;
                line-height:40px;
                padding:0 10px;
                border-radius: 20px;
                font-size:24px;
                margin-left:20px;
            }

        }
        .parking_list_item_line4{
             margin-top: 20px;
            width: 632px;
            flex-direction: row;
            .span1{
                width: 125px;
                display: inline-block;
                font-size: 24px;
                line-height: 44px;
                color: red;
            }
             .span2{
                margin-left: 10px;
                font-size: 24px;
                line-height: 44px;
                color: rgba(0, 0, 0, 0.8);
            }

        }
        .status_bottom{
            .flex();
            justify-content: flex-end;
            padding:18px 28px;
            .btn_primary{
                margin-left:20px;
                display:block;
                height:52px;
                line-height:52px;
                padding-left: 18px ;
                padding-right: 18px;
                border-radius:4px;
                .border(rgba(0, 0, 0, 0.8));
                text-align: center;
                font-size:26px;
                color:rgba(0, 0, 0, 0.8);
            }
            .delete{
                 .border(rgba(253,152,56,1));
                color:#fff;
                background:rgba(253,152,56,1);;
            }
            
            .btn_apply{
                .border(#1740DA);
                color:#fff;
                background:#1740DA;
            }
        }
        .status_bottom1{
            .flex();
            justify-content: flex-end;
            padding:54px 28px;
            .btn_primary{
                margin-left:20px;
                display:block;
                padding-left: 18px ;
                padding-right: 18px;
                height:52px;
                line-height:52px;
                border-radius:4px;
               .border(rgba(0, 0, 0, 0.8));
                text-align: center;
                font-size:26px;
                color:rgba(0, 0, 0, 0.8);
            }
            .delete{
                 .border(rgba(253,152,56,1));
                color:#fff;
                background:rgba(253,152,56,1);;
            }
            .btn_apply{
                .border(#1740DA);
                color:#fff;
                background:#1740DA;
            }
        }
        .parking_list_item_line5{
             margin-top: 20px;
            width: 660px;
            flex-direction: row;
            display: flex;
            justify-content: center;
            .parking_list_item_bt{
                width: 500px;
                height: 80px;
                line-height: 80px;
                text-align: center;
                background: #1740DA;
                color: #fff;
                font-size: 30px;
                border-radius: 10px;

            }

        }
        .parking_list_item_line6{
            margin-top: 20px;
            width: 660px;
            flex-direction: row;
            display: flex;
            justify-content: space-between;
            .footer_btn{
                width: 270px;
                height: 80px;
                line-height: 80px;
                text-align: center;
                background: #1740DA;
                color: #fff;
                font-size: 30px;
                border-radius: 10px;

            }
            .left{
                margin-left: 30px;
            }
            .right{
                margin-right: 30px;
            }

        }
        .hb_tips {
            margin-top: 20px;
            width: 652px;
            flex-direction: row;
            display: flex;
            .flex();
           padding-left: 0px;
           padding-right: 14px;
           padding-top:14px;
           padding-bottom: 14px;
            .borderT(#F4E2D2);
            background: #feeedf;
            .hint_icon {
                margin-top:4px;
                width: 28px;
                height: 28px;
                margin-left: 20px;
                margin-right: 14px;
            }
            p {
                width:532px;
                font-size: 26px;
                line-height: 36px;
                color: #8e7f71;
                span {
                    color: #fd9838;
                }
            }
            .close_icon {
                margin-top:-4px;
                width: 44px;
                height: 44px;
            }
        }
       
    }
}
.bottom_box{
    width: 100%;
    height: 20px;
    display: flex;
}

</style>